import { ImageDTO, ImageLoadRequest, ImageTypeDTO, RasterDTO } from '@/model';
import { apiGenericDelete, apiGenericGet, apiGenericPost } from '@/service';
import { getApiUrl, getApiUrlWithParams } from '@/util';
import { DeleteResponse, GenericPostResponse, SaveResponse } from '@/type';
import { RealTimeImagePreviewRequest } from '@model/image/RealTimeImagePreviewRequest';

const BASE_URL = '/api/v1/image';

export const listImageAPI = (
  types?: ImageTypeDTO[],
  layoutId?: number,
): Promise<ImageDTO[]> =>
  apiGenericGet(
    getApiUrlWithParams(BASE_URL, '/list', {
      types,
      layoutId,
    }),
  );

export const loadImageByIdAPI = (
  request: ImageLoadRequest,
): Promise<GenericPostResponse<ImageDTO>> =>
  apiGenericPost(getApiUrl(BASE_URL, '/load'), request, true);

export const loadRealTimeImagePreviewAPI = (
  request: RealTimeImagePreviewRequest,
): Promise<GenericPostResponse<RasterDTO>> =>
  apiGenericPost(getApiUrl(BASE_URL, '/loadRealTimePreview'), request, true);

export const saveImageAPI = (request: ImageDTO): SaveResponse =>
  apiGenericPost(getApiUrl(BASE_URL, '/save'), request);

export const deleteImageAPI = (id: number): DeleteResponse =>
  apiGenericDelete(getApiUrl(BASE_URL, '/remove'), 'id', id);
